import { Autocomplete, Box, Button, IconButton, Stack, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useUsersQuery } from '../../../hooks/queries.js';


const UsersSelectBox = ({devUser, setDevUser, defaultValue}) => {

    //console.log(defaultValue);
    
    const body = { comando: "CMD_GET_USERS" };
    const { isPending, isError, data, error } = useUsersQuery(body);    //useUsersSelectBox devuelve el objeto data con los siguiente datos: {success, message, data}
                                                                            //entonces data tiene:
                                                                            //          data.success        - Resultado de la consulta al servidor
                                                                            //          data.message        - Mensaje resultado de la consulta al servidor
                                                                            //          data.data           - A su vez data.data contiene un array denominado rows

    if (isPending) return <span>Cargando...</span>
    if (isError) return `Error: ${error.message}`

    const users = data.result.rows;   //Del objeto data se toma el array del subojeto data
    
    if(users) {
        var usuariosOptions = users.map((user) => (
            { id: user.id, label: user.name, cel: user.celular }
        ))

        if(devUser.id > 0) {
            let tempUser = usuariosOptions.find((user) => {
                return user.id === devUser.id;
            })
            //setDefaultUser(tempUser);

            //setDevUser({ id: defaultUser.id, label: defaultUser.name, cel: defaultUser.celular });
        }
        //console.log(defaultUser);
    }

    const handleUsuarioChange = (textContent, value) => {
            //setDevUserId(value.id);
            //setDevUserName(value.label)
            setDevUser({id: value.id, label: value.label, cel: value.cel});
            //console.log(value);
        }
    

    return (
        <Autocomplete
            disablePortal={false}
            id="combo-box"
            options={usuariosOptions}
            fullWidth
            renderInput={(params) => <TextField {...params} label="Usuario" />}
            ListboxProps={{ style: { maxHeight: 150 } }}
            //defaultValue={"Seleccionar"}
            defaultValue={defaultValue ? defaultValue : "Seleccionar Usuario"}
            //value={devUser.label}
            onChange={(event, value) => handleUsuarioChange(event.currentTarget.textContent, value)}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            required
        />
    )
}

export default UsersSelectBox